import * as React from 'react';

const LAPTOP_BREAKPOINT = 1440;

export function useIsLaptop({ breakpoint = LAPTOP_BREAKPOINT }: { breakpoint?: number } = {}) {
  const [isLaptop, setIsLaptop] = React.useState<boolean | undefined>(undefined);

  React.useEffect(() => {
    const mql = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const onChange = () => {
      setIsLaptop(window.innerWidth < breakpoint);
    };
    mql.addEventListener('change', onChange);
    setIsLaptop(window.innerWidth < breakpoint);
    return () => mql.removeEventListener('change', onChange);
  }, []);

  return !!isLaptop;
}
